// @ts-ignore TODO: revisit redux typings
import { AppDispatch } from '../../App';

import { ErrorTypes } from '@/services/api/errorCodes';
import { apiClient } from '@/api/client'
import { PropertyKeyModel } from '@/models/property-keys'
import {
    SET_PROPERTY_KEYS_ERROR_CODE,
    SET_PROPERTY_KEYS_LOADING_STATE,
    SET_PROPERTY_KEYS,
    REMOVE_PROPERTY_KEYS,
    SET_PROPERTY_SCHEDULED_KEYS_DATE,
    SET_SCHEDULED_PROPERTY_KEYS_LOADING_STATE,
} from '@/redux/ActionTypes/property-keys'

export const setPropertyKeys = (propertyKeys: PropertyKeyModel[]) => (dispatch: AppDispatch) => {
    dispatch({
        type: SET_PROPERTY_KEYS,
        propertyKeys,
    });
};

export const setScheduledKeysDate = (scheduledKeysDate: Date | null) => (dispatch: AppDispatch) => {
    dispatch({
        type: SET_PROPERTY_SCHEDULED_KEYS_DATE,
        scheduledKeysDate,
    });
};

export const deletePropertyKeys = () => (dispatch: AppDispatch) => {
    dispatch({
        type: REMOVE_PROPERTY_KEYS
    });
};

export const setLoadingState = (isLoading: boolean) => (dispatch: AppDispatch) => {
    dispatch({
        type: SET_PROPERTY_KEYS_LOADING_STATE,
        isLoading,
    });
};

export const setScheduledKeysLoadingState = (isLoading: boolean) => (dispatch: AppDispatch) => {
    dispatch({
        type: SET_SCHEDULED_PROPERTY_KEYS_LOADING_STATE,
        isLoading,
    });
};

export const fetchError = (error: ErrorTypes) => (dispatch: AppDispatch) => {
    dispatch({
        type: SET_PROPERTY_KEYS_ERROR_CODE,
        error,
    });
    dispatch(setLoadingState(false));
};

export const fetchReservationPropertyKeys = (reservationId: string) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(setLoadingState(true));
    const propertyKeys = await apiClient.propertyKeys.getReservationPropertyKeys(reservationId);

    dispatch(setPropertyKeys(propertyKeys));
    dispatch(setLoadingState(false));
};

export const createPropertyKeys = (reservationId: string) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(setLoadingState(true));

    await apiClient.propertyKeys.createReservationPropertyKeys(reservationId);

    dispatch(setLoadingState(false));
};

export const removePropertyKeys = (propertyKeyIds: string[]) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(setLoadingState(true));

    await apiClient.propertyKeys.removePropertyKeys(propertyKeyIds);
    dispatch(deletePropertyKeys());

    dispatch(setLoadingState(false));
};

export const fetchScheduledKeys = (reservationId: string) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(setScheduledKeysLoadingState(true));

    const expectedDate = await apiClient.propertyKeys.getScheduledKeys(reservationId);

    dispatch(setScheduledKeysDate(expectedDate));
    dispatch(setScheduledKeysLoadingState(false));
}
